import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import {KngActivityIndicatorService} from "@layout/kingswell/services/kngActivityIndicator.service";

@Component({
  selector: 'app-login',
  template: '<div>\n' +
  '        <h4 class="medium">Access Denied</h4>\n' +
  '        <p class="b2 book">Please try signing in again or contact your administrator.</p>\n' +
  '      </div>'
})
export class UnauthorizedAccessComponent implements OnInit {

  constructor(private _auth: AuthService, private _router: Router, private kngActivityIndicator: KngActivityIndicatorService) { }

  ngOnInit() {
    this.kngActivityIndicator.close();
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/auth/UnauthorizedAccess.component.ts